import Head from 'next/head';
import { useRef } from 'react';
import { ThemeProvider } from 'styled-components';

import { theme } from 'theme';
import { Footer, Header } from '@components/organisms';
import GlobalStyles from '@styles/GlobalStyles';

import type { AppProps } from 'next/app';

import '@styles/base.css';
import { PageTitle } from '@components/atoms';

export default function MyApp({ Component, pageProps }: AppProps) {
  const aboutRef = useRef<HTMLDivElement>(null);
  const locationsRef = useRef<HTMLDivElement>(null);
  const reviewsRef = useRef<HTMLDivElement>(null);
  const partnersRef = useRef<HTMLDivElement>(null);
  const contactUsRef = useRef<HTMLDivElement>(null);

  const refs = [aboutRef, locationsRef, reviewsRef, partnersRef, contactUsRef];

  return (
    <ThemeProvider theme={theme}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="description"
          content="Streamline your logistics with freightbox cross docking solutions!"
        />
      </Head>

      <PageTitle title="Greenline Logistics" />
      <Header refs={refs} />

      <main>
        <Component {...pageProps} refs={refs} />
      </main>

      <Footer refs={refs} />

      <GlobalStyles />
    </ThemeProvider>
  );
}
